<template>
  <div class="shopping-cart" v-if="isShowPage">
    <div v-if="isList">
      <ShoppingCartCard v-for="(item,index) in shopCartItems" :key="index" :cardTitle="item.name">
        <EnterainmentCard :cardData="item.children" :allBookingGuests="allBookingGuests" @deleteRefreh="deleteRefreh"/>
      </ShoppingCartCard>
      <!--超凡观光-->
      <div class="card-box" v-if="shorexPartViews.length > 0">
        <ShoppingCartCard :cardTitle="'超凡观光'">
          <SightseeingCard @checkval="checkval" :cardData="shorexPartViews" :checkId="listData.selectedShorex" :isShowRadio="true" :orderStatus="listData.orderStatus"/>
        </ShoppingCartCard>
      </div>
    </div>
    <!--空购物车-->
    <EmptyShoppingCart v-if="!isList"/>
    <!--结算-->
    <div class="flex-center-box bottom-box" v-show="isList">
      <div class="price-box">
        <div class="price"> <span class="title">总计：</span> <span class="price-color">{{total | priceFormat}}</span> 美元</div>
        <div class="tips">(含服务费 <span class="price-color">{{priceDiscountedServiceChargeTotal | priceFormat}}</span> 美元)</div>
      </div>
      <div class="settlement-btn" @click="goOrderDetail"> 结算（{{cartNumber}}）</div>
    </div>
  </div>
</template>

<script>
import EnterainmentCard from './shopping_cart/EntertainmentCard'
import SightseeingCard from './shopping_cart/SightseeingCard'
import EmptyShoppingCart from './shopping_cart/EmptyShoppingCart'
import ShoppingCartCard from './shopping_cart/ShoppingCartCard'
import api from '@/api'
import { showLoading, hideLoading } from '@/utils/tools'
// import groupBy from 'lodash/groupBy'
import { checkLoginStatus, gioTracking } from '@/plugins/common.js'
import { getCookie } from '@/utils/cookie'

export default {
  name: 'PageShoppingCart',

  components: {
    EnterainmentCard,
    SightseeingCard,
    EmptyShoppingCart,
    ShoppingCartCard
  },

  data () {
    return {
      isShowPage: true,
      checked: '',
      showCheck: true,
      isList: true,
      listNumber: 0,
      listData: {},
      shopCartItems: {},
      shorexPartViews: [],
      cartNumber: 0,
      allBookingGuests: [],
      checkArry: [],
      total: 0,
      priceDiscountedServiceChargeTotal: 0
    }
  },

  filters: {
    priceFormat (current) {
      return current % 1 === 0 ? current : current.toFixed(2)
    }
  },

  activated () {
    this.isShowPage = true
    checkLoginStatus().then(() => {
      this.getBookingInfo()
    })
  },

  methods: {
    goOrderDetail () {
      gioTracking('track', 'evt_goCheckOut')
      this.$router.push('/Rccl.PCP/Order/Checkout?isFromCart=true')
    },
    // 获取购物车数据
    async getBookingInfo () {
      showLoading()
      const { errCode, errMsg, data } = await api.getShoppingCartsList()
      hideLoading()
      if (errCode === 0) {
        if (data && data.selectedShorex === 0 && data.shopCartItems.length === 0) {
          this.$store.commit('store', {
            goodsCartNum: 0
          })
          this.isList = false
          // this.isShowPage = false
        } else {
          this.listData = data
          this.total = data.total
          this.priceDiscountedServiceChargeTotal = data.priceDiscountedServiceChargeTotal
          // this.shopCartItems = groupBy(data.shopCartItems, 'categoryName')
          const newarr = this.groupArr(data.shopCartItems, 'categoryName')
          for (let index = 0; index < newarr.length; index++) {
            newarr[index].children = this.groupArr(newarr[index].children, 'subCategoryName')
          }
          this.shopCartItems = newarr
          // if (data.selectedShorex === null || (data.bookedShorex && data.bookedShorex.shorexType === 1)) {
          //   this.shorexPartViews = data.shorexPartViews
          // } else {
          //   const checkItem = data.shorexPartViews.filter(arr => arr.id === data.selectedShorex)
          //   if (checkItem.shorexType === 1) {
          //     this.shorexPartViews = data.shorexPartViews
          //   } else {
          //     this.shorexPartViews = checkItem
          //   }
          // }
          // if (data.bookedShorex) {
          //   if (data.bookedShorex.shorexType === 1) {
          //     this.shorexPartViews = data.shorexPartViews
          //   } else {
          //     this.shorexPartViews[0] = data.bookedShorex
          //   }
          // }
          if (!getCookie('shorexId')) {
            this.shorexPartViews = data.shorexPartViews
          } else {
            this.shorexPartViews = []
            this.shorexPartViews = data.shorexPartViews.filter(arr => arr.id === data.selectedShorex)
          }
          this.isList = true
          this.cartNumber = 0
          data.shopCartItems.map(item => {
            this.cartNumber = this.cartNumber + item.qty
          })
          // this.cartNumber = data.shopCartItems.length
          this.allBookingGuests = data.allBookingGuests
          if (data.selectedShorex !== 0) this.cartNumber++
          this.checkArry[0] = data.selectedShorex
          this.$store.commit('store', {
            goodsCartNum: this.cartNumber
          })
        }
      } else {
        this.isShowPage = true
        this.isList = false
        window.console.log(errMsg)
      }
    },
    checkval () {
      this.getBookingInfo()
    },
    deleteRefreh () {
      this.getBookingInfo()
    },
    groupArr (list, field) {
      let fieldList = []
      const att = []
      list.map(e => {
        fieldList.push(e[field])
      })
      fieldList = fieldList.filter((e, i, arr) => {
        return arr.indexOf(e) === i
      })
      for (let index = 0; index < fieldList.length; index++) {
        const arr = list.filter(e => {
          return e[field] === fieldList[index]
        })
        att.push({
          name: arr[0][field],
          children: arr
        })
      }
      return att
    }
  }
}
</script>

<style lang="less" scoped>
.shopping-cart {
  padding: 30px 50px 113px;
  .card-box{
    margin-bottom: 20px;
  }
  .bottom-box{
    position: fixed;
    bottom: 126px;
    left: 0;
    right: 0;
    height: 117px;
    font-size: 24px;
    background-color: #ffffff;
    padding-left: 50px;
    z-index: 90;
    .price-box{
      flex: 1;
      text-align: right;
      color: @main-gray4;
      padding-right: 30px;
      .price-color{
        font-size: 30px;
      }
      .title{
        color: @main-gray2;
      }
      .tips{
        font-size: 20px;
      }
    }
    .settlement-btn{
      width: 230px;
      background-color: @second-color;
      color: #ffffff;
      height: 100%;
      align-items: center;
      text-align: center;
      font-size: 30px;
      line-height: 117px;
    }
  }
  ::v-deep .card-cell {
    background-color: #ffffff;
    border-radius: 6px;
    overflow: hidden;
    font-size: 20px;
    color: @main-gray4;
    line-height: 1.8;
    .card-hd {
      font-size: 30px;
      color: @main-gray2;
      padding: 20px;
      border-bottom: 1px solid @main-gray5;
    }
    .card-bd{
      min-height: 100px;
    }
  }
  ::v-deep .item-btn{
    width: 85px;
    height: 46px;
    line-height: 46px;
    background-color: #1174b8;
    color: #ffffff;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
    border-radius: 6px;
    font-size: .18rem;
    padding: 0;
    border:none;
    &.btn-linear-gradient{
      color: @main-gray2;
    }
  }
  ::v-deep .price-color{
    color: @second-color;
  }
  ::v-deep .blue-color{
    color: #1174b8;
  }
}
</style>
